import { extractDomain } from "../utils";

export const MIDDLEWARE = "/edge/dashboard/middleware";
export const RECRUITER_ACTIONS_MIDDLEWARE = "/edge/foldermanagement/recruiter-actions-middleware"
const RECRUITER_ACTIONS = '/recruiter-edge-actions/api/v1'

export const ENDPOINTS = {
  getUserData: "/cassowary/session/getuser",
  getHeader: "/recruiter4chat/common/get/header",
  getInterested:"/v2/data.html",
  getMasterData: "/v4/recruiter/v4/recruiter-srp/api/v1/master-data",
  getMasterDataRaven: "/v4/recruiter/v4/recruiter-srp/api/v1/ravenMasterData",
  getCampaign: "/outreach-edge-api/api/v1/campaign/overview",
  getManageFolderRec: "/edge-folder-management/api/v2",
  manageFolderShare: "/edge-folder-management/api/v2/folder/share",
  redirectToCampaign: "/outreach-edge-api/api/v1/campaign/initiation",
  downloadExcel: "/edge-folder-management/recruiter/v2/downloadExcel",
  moveToState: `${RECRUITER_ACTIONS}/move_to_state`,
  removeProfile: `${RECRUITER_ACTIONS}/remove_profile`,
  inventory: "/edge-dashboard/api/v2/actions/inventory",
  getFMRecDetails : "/edge-folder-management/api/v2/profile/recruiter",
  getCandidatePipeline : '/edge-folder-management/api/v2/folder/candidate-pipeline',
  getDownloadProfilesPolling :'/edge-folder-management/api/polling/excel',
  healthTracker: "/recruiter-edge-event-tracking/api/v1/tracking/page/load/event",
  getInsightFolders:'/edge-dashboard/api/v2/insights/folders',
  getInsightJobs:'/edge-dashboard/api/v2/insights/jobs',
  getInsightEmailCampaign:'/edge-dashboard/api/v2/insights/email-campaign',
  getSavedSearch:'/edge-dashboard/api/v2/saved-search/search',
  pauseCampaign: "/outreach-edge-api/api/v1/campaign/pause",
  getCampaignDetails:'/outreach-edge-api/api/v1/campaign/candidate',
  getRececntSearches:`/edge/recruiter/v4/recruiter-srp/api/v1/recentSearches`,
  getCommuincations:"/edge-dashboard/api/v2/actions/campaign",
  getDownloads:"/edge-dashboard/api/v2/actions/downloads",
  gettAlerts:"/edge-dashboard/api/v2/actions/alerts",
  scheduleNow:"/outreach-edge-api/api/v1/campaign/draft/schedule",
  scheduleCampaign:'/outreach-edge-api/api/v1/campaign/draft/schedule/',
  getLinkedSearchUrl: "/edge/recruiter/v4/recruiter-srp/api/v1/getSavedSearch",
  deleteJob:"/edge-dashboard/api/v2/job/delete",
  renew:"/edge_mjp/renewJob/",
  topUp:"/edge-dashboard/api/v2/actions/topup",
  getRecruiters:"/edge-folder-management/api/v2/recruiters",
  shareFolder:"/edge-folder-management/api/v2/folder/share",
  checkInventory: "/edge-folder-management/api/excel/inventory",
  mailboxCheck:"/outreach-edge-api/api/v1/mail/authenticate?page=DASHBOARD",
  campaignMarkRead:"/edge-dashboard/api/v2/actions/campaign/markRead",
  downloadsMarkRead:"/edge-dashboard/api/v2/actions/downloads/markRead",
  alertMarkRead:"/edge-dashboard/api/v2/actions/alerts/read",
  checkEmail:"/edge-folder-management/api/excel/mail",
  downloadExcelNew:"/edge-folder-management/recruiter/v3/downloadExcel",
  getProfilesCount: "/edge-folder-management/api/v2/folder/profiles/count/check",
  checkRevampService: "/edge-dashboard/v2/dashboard/revamp/services",
};

export const API_HEADERS: HeadersInit | undefined = {
  domain: extractDomain(),
};
